module.exports = __webpack_public_path__ + "static/img/zhong5.deb0b67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong5.png
// module id = 2wJo
// module chunks = 16